export class ErrorObject {
  code: string;
  details: Array<Object>;

  constructor() {
    this.code = '99.999';
  }

  hasDetails(): boolean {
    return this.details.length > 0 ? true : false;
  }
}
